import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { AtpValidators } from '../atp-core/atp-core';
import { HttpService } from '../services/http.service';
import { HttpErrorsService } from '../services/http-errors.service';
import { AtpHttpErrorHandler } from '../atp-core/services/atp-http-errors.service';
import { AtpBasePageComponent } from '../atp-core/atp-base-page-component';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AtpActionsPopupData, AtpActionsPopup } from '../atp-core/components/atp-actions-popup/atp-actions-popup.component';

@Component({
  selector: 'password-recovery',
  templateUrl: './password-recovery.component.html'
})
export class PasswordRecoveryComponent extends AtpBasePageComponent implements OnInit {

  constructor(private _api: HttpService, private _httpErrors: HttpErrorsService, private _dialog: MatDialog, private _router: Router, protected activatedRoute: ActivatedRoute) {
    super();
  }

  emailFormGroup: FormGroup;
  changePasswordFormGroup: FormGroup;

  protected navigateSubscription: Subscription;
  protected queryParams: any;

  ngOnInit() {
    this.navigateSubscription = this.activatedRoute.data.subscribe(
      data => {
        const queryParams = data.resolver.queryParams;
        if (queryParams.email || queryParams.email == '') {
          this.emailFormGroup = new FormGroup({
            login: new FormControl(queryParams.email, [AtpValidators.pattern(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/), AtpValidators.required])
          });
          this.changePasswordFormGroup = null;
        }
        else if (queryParams.token) {
          this.emailFormGroup = null;
          this.queryParams = queryParams;
          this.changePasswordFormGroup = new FormGroup({
            password: new FormControl('', [AtpValidators.stringLength(16, 5), AtpValidators.regularExpression('^[A-Za-z0-9]+$', 'first'), AtpValidators.regularExpression('\S*[a-z]\S*', 'second'), AtpValidators.regularExpression('\S*[0-9]\S*', 'third'), AtpValidators.required]),
          });
          this.changePasswordFormGroup.addControl('confirmPassword', new FormControl('', [AtpValidators.compare(this.changePasswordFormGroup, 'password')]));
        }
      }
    );
  }

  get loginErrorLabel(): string {
    return this.emailFormGroup.invalid ? (this.emailFormGroup.controls.login.errors.pattern ? 'введен неверно.' : this.emailFormGroup.controls.login.errors.required ? 'обязателен для заполнения.' : null) : null;
  }

  get passwordErrorLabel(): string {
    let result: string = null;
    if (this.changePasswordFormGroup && this.changePasswordFormGroup.controls.password.invalid) {
      result = this.changePasswordFormGroup.controls.password.errors.required ? 'обязательно для заполнения.' : null;
      result = result || (this.changePasswordFormGroup.controls.password.errors.stringlength ? 'должен состоять минимум из 5 и максимум из 16 символов.' : null);
      result = result || (this.changePasswordFormGroup.controls.password.errors.first ? 'должен содержать только латинские буквы и цифры.' : null);
      result = result || (this.changePasswordFormGroup.controls.password.errors.second ? 'должен содержать минимум 1 букву в нижнем регистре.' : null);
      result = result || (this.changePasswordFormGroup.controls.password.errors.third ? 'должен содержать минимум 1 цифру.' : null);
    }
    return result;
  }

  get confirmPasswordErrorLabel(): string {
    return this.changePasswordFormGroup ? (this.changePasswordFormGroup.controls.confirmPassword.invalid ? 'не совпадает с паролем' : null) : null;
  }

  emailFormSubmit() {
    this.isBlockedPage = true;
    this._api.passwordRecovery(this.emailFormGroup.value.login).subscribe(
      (result: void) => {
        this.emailFormGroup = null;
        this.isBlockedPage = false;
      },
      err => {
        this._httpErrors.process(err.status, () => { this.emailFormSubmit(); }, this, [new AtpHttpErrorHandler(400, err.error)]);
      }
    );
  }

  changePasswordFormSubmit() {
    let data = this.changePasswordFormGroup.value;
    data.login = this.queryParams.login;
    this.isBlockedPage = true;
    this._api.changePassword(this.queryParams.token, data).subscribe(
      (result: void) => {
        let data = new AtpActionsPopupData('Восстановление пароля', 'Восстановление пароля прошло успешно.', 'Закрыть', null);
        data.successBtnColor = 'primary';
        data.titleColor = '#006600';
        const dialogRef = this._dialog.open(AtpActionsPopup, {
          width: '450px',
          data: data,
        });

        dialogRef.afterClosed().subscribe(
          (result) => {
            this._router.navigate(['/auth']);
          }
        );

        setTimeout(() => {
          dialogRef.close(null);
        }, 2000);

        this.isBlockedPage = false;
      },
      err => {
        this._httpErrors.process(err.status, () => { this.changePasswordFormSubmit(); }, this, [new AtpHttpErrorHandler(400, err.error)]);
      }
    );
  }

}
